import { render, staticRenderFns } from "./ReviewAndAddFunds.vue?vue&type=template&id=28b04ad4&"
import script from "./ReviewAndAddFunds.vue?vue&type=script&lang=js&"
export * from "./ReviewAndAddFunds.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAndAddFunds.vue?vue&type=style&index=0&id=28b04ad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports